import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { theme } from "../../../App";
import { darkGrey, lightOrange, yellow, zindex } from "../../graphic/theme";
import { Motion } from "../../components/Base/Motion";
import { setConsent } from "firebase/analytics";

const cookies = "cookies_accepted_bb";
const cookie_session = "cookies_session_bb";

const pcFirst =
    "Těší nás, že jste s námi. Za účelem zlepšení funkčnosti našeho webu a poskytnutí relevantního obsahu a služeb používáme soubory cookie.";
const pcTablet =
    "Pokud souhlasíte s používáním souborů cookie, klikněte na tlačítko „Přijmout vše“. Pro více informací o tom, jak zpracováváme osobní údaje a používáme soubory cookie si prosím přečtěte naše";
const mobileText =
    "Pokud souhlasíte s používáním souborů cookie, klikněte na tlačítko „Přijmout vše“. Pro více informací si prosím přečtěte naše";
const allEndText = (
    <>
        {" "}
        <a
            href="https://bagr-brno.cz/soukromi"
            target="_blank"
            rel="noreferrer"
            style={{ color: darkGrey }}
        >
            Zásady ochrany osobních údajů
        </a>{" "}
        a{" "}
        <a
            href="https://bagr-brno.cz/cookies"
            target="_blank"
            rel="noreferrer"
            style={{ color: darkGrey }}
        >
            Cookies policy
        </a>
    </>
);

// Full default
const fullConsent = {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

// Consent Required Always
const partialConsent = {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    personalization_storage: "granted",
    security_storage: "granted",
};

function setDefaultConsent() {
    setConsent(partialConsent);
    if (window?.gtag) {
        window.gtag("consent", partialConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "revoke");
    }
}

function setFullConsent() {
    setConsent(fullConsent);
    if (window?.gtag) {
        window.gtag("consent", fullConsent);
    }
    if (window?.fbq) {
        window.fbq("consent", "grant");
    }
}

function acceptCookies(all = false) {
    if (!localStorage) return;
    localStorage.setItem(cookies, all ? "all" : "true");
}

export function wasCookieBarClicked() {
    if (!localStorage) return true;
    return Boolean(localStorage?.getItem(cookies) === "all");
}

export function areCookiesAccepted() {
    if (!localStorage || localStorage.getItem(cookies) == null) {
        return true;

    }
    return Boolean(localStorage?.getItem(cookies) === "all");
}

function acceptedThisSession() {
    try {
        if (!sessionStorage) return false;
        return sessionStorage.getItem(cookie_session) === "true";
    } catch (error) {
        return false;
    }
}

function acceptSession() {
    try {
        if (!sessionStorage) return;
        sessionStorage.setItem(cookie_session, "true");
    } catch (e) {
        return;
    }
}

export default function CookieBar({ open, setOpen }) {
    const [shown, setShown] = useState(
        open !== undefined ? open : !wasCookieBarClicked()
    );
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.only("sm"));

    useEffect(() => {
        if (open !== undefined && shown != open) {
            setShown(open);
        }
    }, [open]);

    useEffect(() => {
        setDefaultConsent();
    }, [])

    if (acceptedThisSession()) return <></>;

    return (
        <Box
            sx={{
                width: "100%",
                maxHeight: shown ? "220px" : "0px",
                position: "fixed",
                bottom: 0,
                zIndex: zindex.maxOverlay,
                //boxShadow: "0px -1px 5px 0px rgba(115,117,122,0.75)",
                transition: "max-height .4s ease-in-out",
                textAlign: "left",
            }}
        >
            <Box

                sx={{
                    minHeight: "100px",
                    bgcolor: lightOrange,
                    opacity: 0.9,

                }}
            >
                <Box maxWidth={'lg'} sx={{
                    display: "flex",
                    flexDirection: "row",
                    mx: 'auto'
                }}>
                    <Typography sx={{ color: darkGrey, mx: "20px", my: "20px" }}>
                        {!(mobile || tablet) ? <>{pcFirst} </> : ""}
                        {mobile ? mobileText : pcTablet}
                        {allEndText}
                    </Typography>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            alignContent: "center",
                            ml: "auto",
                            mr: "20px",
                            mt: "20px",
                        }}
                    >
                        <Motion scale={1.03}>
                            <Box
                                sx={{
                                    minWidth: "120px",
                                    height: "36px",
                                    bgcolor: darkGrey,
                                    borderRadius: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    alignContent: "center",
                                    cursor: "pointer",
                                    opacity: 1,
                                }}
                                onClick={() => {
                                    setFullConsent();
                                    acceptCookies(true);
                                    if (setOpen) setOpen(false);
                                    setShown(false);
                                }}
                            >
                                <Typography sx={{ color: 'white', fontWeight: "bold" }}>
                                    Přijmout vše
                                </Typography>
                            </Box>
                        </Motion>
                        <Typography
                            sx={{
                                color: darkGrey,
                                fontWeight: "bold",
                                mt: "12px",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                setDefaultConsent();
                                acceptCookies();
                                acceptSession();
                                if (setOpen) setOpen(false);
                                setShown(false);
                            }}
                        >
                            Jen nezbytné
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
